import '../css/index.scss';
import $ from 'jquery';
import { setupLenis } from '../scripts/lenis.js';

'use strict';

/* ======================================
  定数・ユーティリティ
====================================== */

let windowWidth = $(window).width();
let windowHeight = $(window).height();
let adjust = null;

const BREAKPOINT_SP = 768;
const isDesktop = () => window.innerWidth > BREAKPOINT_SP;
const setHeight = () => {
  const winHeight = document.documentElement.clientHeight;
  document.querySelectorAll(".setHeight").forEach((el) => {
    el.style.height = `${winHeight}px`;
  });
};
const setVh = () => {
  const vh = document.documentElement.clientHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

/* ======================================
  Loading
====================================== */

function hideLoading() {
  const el = document.getElementById('loading');
  if (!el) return;

  el.style.transition = 'opacity .4s ease';
  el.style.opacity = '0';

  el.addEventListener('transitionend', () => {
    el.style.display = 'none';
  }, { once: true });
}

function handleLoading() {
  const isSP = window.innerWidth <= BREAKPOINT_SP;
  isSP ? setTimeout(hideLoading, 400) : hideLoading();
}

/* ======================================
  UA（そのまま）
====================================== */

const _ua = (function(u){
  return {
    Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

if(_ua.Mobile || _ua.Tablet){
  window.addEventListener('load', setHeight);
  window.addEventListener('resize', setHeight);
}

/* ======================================
  Lenis / Height
====================================== */

let lenis = null;

function setupScrollEngine() {
  if (isDesktop()) {
    lenis = setupLenis();
  } else {
    setHeight();
  }
}

/* ======================================
  Navigation
====================================== */

function setupAnchorScroll() {
  document.querySelectorAll('.nav-item-link').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.getElementById(link.dataset.target);
      if (!target) return;

      lenis
        ? lenis.scrollTo(target)
        : target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

/* ======================================
  Scroll Effects
====================================== */

function scrollAddClass() {
  const vh = window.innerHeight;
  document.querySelectorAll('.animate').forEach(el => {
    const pos = el.getBoundingClientRect().top + vh * 0.24;
    if (pos < vh) el.classList.add('is_animated');
  });
}

window.addEventListener('scroll', scrollAddClass);


/* ======================================
  Scroll Handler（軽量化）
====================================== */

let ticking = false;

function handleScroll() {
  if (!ticking) {
    requestAnimationFrame(() => {
      checkScroll();
      scrollAddClass();
      ticking = false;
    });
    ticking = true;
  }
}

/* ======================================
  Text Lines
====================================== */

function setupTextLines() {
  document.querySelectorAll('.txtlines').forEach((el, index) => {
    if (!el.dataset.original) {
      el.dataset.original = el.textContent;
    }

    const lines = el.dataset.original.split('\n');
    const delay = 0.08;

    el.innerHTML = lines.map((line, i) => {
      const extra = index === 0 ? 0.65 : 0;
      return `<span class="line" style="transition-delay:${delay * (i + 1) + extra}s">${line}</span>`;
    }).join('');
  });
}


/* ======================================
  Resize
====================================== */

let resizeTimer;

function handleResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    setVh();
    setupTextLines();
    lenis?.resize();
  }, 200);
}

/* ======================================
  Init
====================================== */

function init() {
  setupScrollEngine();
  setupAnchorScroll();
  setupTextLines();
  setVh();
  handleScroll();
}

document.addEventListener('DOMContentLoaded', init);

/* ======================================
  Events
====================================== */

window.addEventListener('load', handleLoading);
window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', handleResize);

/* ======================================
  既存処理
====================================== */

window.addEventListener('load',function(){

  if (windowWidth <= BREAKPOINT_SP) {
    adjust = windowHeight * .25;
  } else {
    adjust = windowHeight * .15;
  }

  const body = document.querySelector('body');
  setTimeout(() => {
    body.classList.add('opening');
    setTimeout(() => {
      body.classList.add('complete');
      body.classList.remove('opening');
    },1200);
  },300);

});


/* ======================================
  KV Image
====================================== */

document.addEventListener("DOMContentLoaded", function () {

  const kvimages = document.querySelectorAll(".kvimage");
  let currentSize = '';

  function updateKV(kvimage, baseSrc) {

    const suffix = window.innerWidth <= 768 ? "_sp" : "_pc";
    const Width = window.innerWidth <= 768 ? "1125" : "1800";
    const Height = window.innerWidth <= 768 ? "2009" : "966";

    const sourceKV = document.createElement("source");
    sourceKV.setAttribute("src", baseSrc + suffix + ".webp");
    sourceKV.setAttribute("type", "image/webp");

    const imageKV = document.createElement("img");
    imageKV.setAttribute("src", baseSrc + suffix + ".jpg");
    imageKV.setAttribute("alt", "nivea key visual");
    imageKV.setAttribute("width", Width);
    imageKV.setAttribute("height", Height);

    kvimage.innerHTML = "";
    kvimage.appendChild(sourceKV);
    kvimage.appendChild(imageKV);
  }

  kvimages.forEach((kvimage) => {
    const baseSrc = kvimage.getAttribute("data-src");
    updateKV(kvimage, baseSrc);
  });

  window.addEventListener("resize", function () {
    const newSize = window.innerWidth;

    if (currentSize !== newSize) {
      currentSize = newSize;

      kvimages.forEach((kvimage) => {
        const baseSrc = kvimage.getAttribute("data-src");
        updateKV(kvimage, baseSrc);
      });
    }
  });

});


// ------------------------
// スクロール方向検知
// ------------------------
let lastScrollY = window.scrollY;
let direction = 'down';

window.addEventListener('scroll', () => {
  const currentY = window.scrollY;
  direction = currentY > lastScrollY ? 'down' : 'up';
  lastScrollY = currentY;

  updateBox();
  updateBody();
});


// ------------------------
// 要素取得
// ------------------------
const boxes = document.querySelectorAll('.box-product');
const bodies = document.querySelectorAll('.l-product-body');


// ------------------------
// メイン制御
// ------------------------
function updateBox() {
  const vh = window.innerHeight;

  let nextTarget = null;

  boxes.forEach((box, index) => {
    const rect = box.getBoundingClientRect();
    const target = box.querySelector('.box__content.--first');

    // ========================
    // ▼ 下スクロール
    // ========================
    if (direction === 'down') {

      // boxの下が80%ラインに来たら解除（最優先）
      if (rect.bottom <= vh * 0.8) {
        nextTarget = null;
        return;
      }

      // ① box上が20%ラインきたら...
      if (rect.top <= vh * 0.2 && rect.bottom > 0) {
        nextTarget = target;
      }

      // ② 次のboxの上が50%にきたら...
      if (rect.top <= vh * 0.5 && rect.top > 0) {
        nextTarget = target;
      }
    }

    // ========================
    // ▼ 上スクロール
    // ========================
    if (direction === 'up') {

      // boxの下が75%ラインに来たら解除（最優先）
      if (rect.bottom <= vh * 0.75) {
        nextTarget = null;
        return;
      }

      // ② 次のboxの上が50%にきたら...
      if (rect.top <= vh * 0.5 && rect.top > 0) {
        nextTarget = target;
      }

      // ① box上が10%ラインきたら...
      if (rect.top <= vh * 0.1 && rect.bottom > 0) {
        nextTarget = target;
      }

    }

  });

  // ------------------------
  // 状態更新
  // ------------------------
  boxes.forEach((box) => {
    const target = box.querySelector('.box__content.--first');

    if (target === nextTarget) {
      target.classList.add('is-fixed');
    } else {
      target.classList.remove('is-fixed');
    }
  });
}

function updateBody() {
  const vh = window.innerHeight;

  bodies.forEach((body) => {
    const rect = body.getBoundingClientRect();

    // 👇 画面内にいるか判定（最重要）
    const isInView = rect.bottom > 0 && rect.top < vh;

    // ========================
    // ▼ 下スクロール
    // ========================
    if (direction === 'down') {

      if (!isInView) {
        body.classList.remove('is-active');
        return;
      } else {
        body.classList.add('is-active');
      }
    }

    // ========================
    // ▼ 上スクロール
    // ========================
    if (direction === 'up') {

      if (!isInView) {
        body.classList.remove('is-active');
        return;
      } else {
        body.classList.add('is-active');
      }
    }

  });
}
// ------------------------
// 初期実行
// ------------------------

updateBox();
updateBody();
